import { Button, Input, message } from 'antd'
import React from 'react'
import { Text, View } from 'styles/reactnative'
import API from '../../../utils/api'
import { useToken } from '../../hooks'

const MemoInput = ({ data, mutate = () => {} }: any) => {
	const { data: token } = useToken()
	const [memo, setMemo] = React.useState(data?.bankaccount)

	const [modify, setModify] = React.useState(false)

	const saveMemo = () => {
		API.put('/admin/history/wallet', token + '', {
			id: data?.id,
			memo,
		})
			.then(res => {
				if (res.result.success) {
					message.success('성공')
					mutate()
				} else {
					message.error(res?.result?.message || '실패')
				}
				setModify(false)
			})
			.catch(err => {
				message.error('실패:' + err.message)
			})
	}

	return (
		<>
			{modify ? (
				<View style={{ width: '100%', flexDirection: 'row' }}>
					<Input
						defaultValue={data?.adminmemo}
						value={memo}
						onChange={e => {
							setMemo(e.target.value)
						}}
						size="small"
					/>
					<Button
						size="small"
						type="primary"
						style={{ marginLeft: 5 }}
						onClick={saveMemo}>
						수정
					</Button>
				</View>
			) : (
				<Text
					onClick={() => setModify(true)}
					style={{ cursor: 'pointer' }}>
					{data?.adminmemo || '-'}
				</Text>
			)}
		</>
	)
}

export default React.memo(MemoInput)
